// frontend/src/components/project/StageSwitcher.jsx
import { Button } from '@mui/material';
import PauseIcon from '@mui/icons-material/Pause';
import DoneIcon from '@mui/icons-material/Done';
import StartIcon from '@mui/icons-material/Start';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';

const stateColor = (state) => {
  if (state === '') {
    return { color: 'primary', Icon: PauseIcon };
  }
  if (state === 'start') {
    return { color: 'warning', Icon: StartIcon };
  }
  if (state === 'done') {
    return { color: 'success', Icon: DoneIcon };
  }
  return { color: 'primary', Icon: PauseIcon };
};

const StageSwitcher = ({ item, onSwitch, resetable, changable }) => {
  const currentState = item.state;
  const currentVisible = item?.visible === 'true' || item?.visible;
  const { color, Icon } = stateColor(currentState);

  const onSwitchHandler = () => {
    if (currentState === 'done' && !resetable) return;
    if (!changable) return;
    onSwitch(item?.linkId);
  };

  if (!currentVisible) {
    return (
      <Button variant='outlined' disabled size='small'>
        <DoNotDisturbIcon />
      </Button>
    );
  }

  return (
    <Button
      variant='outlined'
      size='small'
      color={color}
      onClick={onSwitchHandler}
    >
      <Icon />
    </Button>
  );
};

// const StageSwitcher = ({ item, onSwitch, resetable, changable }) => {
//   let content;
//   const currentState = item.state;
//   const currentVisible = item?.visible === 'true' || item?.visible;
//   const [color, icon] = stateColor(currentState);

//   const onSwitchHandler = () => {
//     if (currentState === 'done' && !resetable) return;
//     if (!changable) return;
//     onSwitch(item?.linkId);
//   };

//   if (currentVisible) {
//     content = (
//       <Button
//         variant='outlined'
//         size='small'
//         color={color}
//         onClick={onSwitchHandler}
//       >
//         {icon}
//       </Button>
//     );
//   } else {
//     content = (
//       <Button variant='outlined' disabled size='small'>
//         <DoNotDisturbIcon />
//       </Button>
//     );
//   }

//   return content;
// };
//export default React.memo(StageSwitcher);
export default StageSwitcher;
